import { createCompany } from "../data/repository/company.repo";

export const CreateCompanyUseCase = async (name, address) => {
  try {
    const resp = await createCompany({ name, address });
    console.log(resp);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
